module.exports = __webpack_public_path__ + "static/media/lock.0e1faeee.svg";